/* Imports */
import { onMounted, onUnmounted, ref } from 'vue';

export const useScreenResize = () => {
  /* State */
  const screenWidth = ref(window.innerWidth);

  const handleResize = () => {
    screenWidth.value = document.documentElement.clientWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
    window.removeEventListener('orientationchange', handleResize);
  });

  return { screenWidth };
};
